'use strict';

var deepObjectDiff = require('deep-object-diff');
var isEqual = require('fast-deep-equal/es6');
var cookies = require('js-cookie');

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { };
const DEFAULT_POLLING_TIME = 1000;
class CookieWatcher {
    _cookiesChangeListeners = [];
    _cookieChangeListeners = {};
    _previousCookies = {};
    _pollingTime;
    _watcherDestroy;
    constructor(options) {
        const { pollingTime = DEFAULT_POLLING_TIME } = options || {};
        this._pollingTime = pollingTime;
        this._createWatcher();
    }
    _createWatcher() {
        const isBrowser = typeof window !== 'undefined';
        if (!isBrowser)
            return null;
        const isCookieStoreApiAvailable = 'cookieStore' in window || 'CookieStore' in window;
        if (isCookieStoreApiAvailable) {
            this._watcherDestroy = this._createApiWatcher();
        }
        else {
            this._watcherDestroy = this._createIntervalWatcher();
        }
    }
    _createApiWatcher() {
        const cookieStoreApi = window.cookieStore || window.CookieStore;
        const onChange = (event) => {
            this._emitChange(event);
        };
        if ('addEventListener' in cookieStoreApi) {
            cookieStoreApi.addEventListener('change', onChange);
            return () => {
                cookieStoreApi.removeEventListener('change', onChange);
            };
        }
        if ('onchange' in cookieStoreApi) {
            cookieStoreApi.onchange = onChange;
            return () => {
                cookieStoreApi.onchange = noop;
            };
        }
        return noop;
    }
    _createIntervalWatcher() {
        this._previousCookies = cookies.get();
        const createCookiesChangeEvent = (diff) => {
            const entries = Object.entries(diff);
            const changed = entries.map(([name, value]) => ({ name, value }));
            return { changed };
        };
        const intervalId = setInterval(() => {
            const currentCookies = cookies.get();
            if (!isEqual(this._previousCookies, currentCookies)) {
                const diff = deepObjectDiff.diff(this._previousCookies, currentCookies);
                const event = createCookiesChangeEvent(diff);
                this._emitChange(event);
            }
            this._previousCookies = currentCookies;
        }, this._pollingTime);
        return () => {
            clearInterval(intervalId);
        };
    }
    _callCookiesEventListeners(event) {
        this._cookiesChangeListeners.forEach((listener) => {
            listener(event);
        });
    }
    _callCookieEventListeners(event) {
        const { changed } = event;
        changed.forEach((cookie) => {
            const listeners = this._cookieChangeListeners[cookie.name];
            if (listeners && listeners.length > 0) {
                listeners.forEach((listener) => {
                    listener(cookie);
                });
            }
        });
    }
    _emitChange(event) {
        this._callCookiesEventListeners(event);
        this._callCookieEventListeners(event);
    }
    // eslint-disable-next-line no-dupe-class-members
    addChangeListener(cookieNameOrCallback, callback) {
        const hasCookieName = typeof cookieNameOrCallback === 'string';
        if (hasCookieName) {
            const cookieName = cookieNameOrCallback;
            const cb = callback;
            if (typeof cb === 'undefined') {
                return;
            }
            const existCookieCallbacks = this._cookieChangeListeners[cookieName] || [];
            this._cookieChangeListeners[cookieName] = [...existCookieCallbacks, cb];
            return;
        }
        const cb = cookieNameOrCallback;
        this._cookiesChangeListeners.push(cb);
    }
    removeChangeListener(cookieNameOrCallback, callback) {
        const hasCookieName = typeof cookieNameOrCallback === 'string';
        if (hasCookieName) {
            const cookieName = cookieNameOrCallback;
            const cb = callback;
            const existCookieCallbacks = this._cookieChangeListeners[cookieName] || [];
            this._cookieChangeListeners[cookieName] = existCookieCallbacks.filter((item) => item !== cb);
            return;
        }
        const cb = cookieNameOrCallback;
        this._cookiesChangeListeners = this._cookiesChangeListeners.filter((item) => item !== cb);
    }
    destroy() {
        if (this._watcherDestroy)
            this._watcherDestroy();
        this._cookiesChangeListeners = [];
        this._cookieChangeListeners = {};
    }
}

exports.CookieWatcher = CookieWatcher;
//# sourceMappingURL=cookieWatcher.js.map
